<template>
    <article
        class="forum-row"
        :class="{ 'is-active': active }"
        tabindex="0"
        @click="$emit('open')"
        @keydown.enter="$emit('open')"
    >
        <span class="forum-row__icon" aria-hidden="true">
            <fa icon="fa-solid fa-comments" />
        </span>
        <div class="forum-row__main">
            <h2 class="forum-row__title">{{ title }}</h2>
            <p v-if="description" class="forum-row__description">{{ description }}</p>
        </div>
        <span class="forum-row__meta">
            <fa icon="fa-solid fa-comment" aria-hidden="true" />
            {{ replyLabel }}
        </span>
        <span class="forum-row__meta">
            <fa icon="fa-solid fa-calendar" aria-hidden="true" />
            {{ dateLabel }}
        </span>
        <span class="forum-row__author">
            <ForumAvatar :name="author" size="sm" />
            <span class="forum-row__author-name">{{ author }}</span>
        </span>
        <button type="button" class="forum-row__open" @click.stop="$emit('open')">
            {{ $t('student.forum.viewForum') }}
        </button>
    </article>
</template>

<script>
    import ForumAvatar from './ForumAvatar.vue';

    export default {
        name: 'ForumListItem',
        components: { ForumAvatar },
        props: {
            forum: {
                type: Object,
                required: true,
            },
            active: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['open'],
        computed: {
            source() {
                return this.forum?.raw || this.forum || {};
            },
            title() {
                return this.source.title || '';
            },
            description() {
                return String(this.source.description || '').trim();
            },
            author() {
                return String(this.source.userName || '').trim();
            },
            replyCount() {
                return Number(this.source.commentsQty || 0);
            },
            replyLabel() {
                const key = this.replyCount === 1
                    ? 'student.forum.replyOne'
                    : 'student.forum.replyMany';
                return `${this.replyCount} ${this.$t(key)}`;
            },
            dateLabel() {
                if (!this.source.dateInsert) return '-';
                const date = new Date(this.source.dateInsert);
                if (Number.isNaN(date.getTime())) return '-';
                return date.toLocaleDateString('pt-BR');
            },
        },
    };
</script>
